"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tquery FetchOfferFromFlow($queryData: OfferQuery, $user: UserLog) {\n        fetchOfferFromFlow(queryData: $queryData, user: $user) {\n            success\n            status\n            message\n            body {\n                id\n                name\n                url\n                jump\n                offer_page\n                four_button\n                restricted\n                states\n                offers {\n                    id\n                    title\n                }\n                quick_link_group \n                selection_links {\n                    id\n                    qid\n                    name\n                    text\n                    offer_group\n                    url\n                    jump\n                    google\n                }\n                question_text\n                program_id\n                group_id\n                google\n            }\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GET_OFFER = (0, _graphqlTag.default)(_templateObject());
var _default = GET_OFFER;
exports.default = _default;

//# sourceMappingURL=GET_OFFER.js.map